import { useNavigate } from 'react-router-dom'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import Markdown from 'react-markdown'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css'
import { dateTimeToString } from '../../../utils/date'
import css from './ModalDetallesConversacionBarbeibot.module.css'

const ModalDetallesConversacionBarbeibot = ({
  open,
  conversacion,
  onClose
}) => {
  const navigate = useNavigate()

  const handleVerConversacion = () => {
    navigate(`/barbeibot/historial/conversacion/${conversacion.id}`)
  }

  const getUsuario = interaccion =>
    interaccion.personalId ? 'usuario' : 'barbeibot'

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>
        Conversación del {dateTimeToString(conversacion.fecha)}
      </DialogTitle>
      <DialogContent className={css.main}>
        <div className={css.chat}>
          {conversacion.interacciones.map((interaccion, index) => (
            <div
              key={index}
              className={css.item}
              data-user={getUsuario(interaccion)}
            >
              <Typography variant='subtitle2' className={css.nombre}>
                {interaccion.personalNombre || 'Barbeibot'}
              </Typography>
              <div className={css.markdownContainer}>
                <Markdown
                  remarkPlugins={[remarkMath]}
                  rehypePlugins={[rehypeKatex]}
                >
                  {interaccion.contenido}
                </Markdown>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={handleVerConversacion}>
          Ver conversación
        </Button>
        <Button color='error' onClick={onClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalDetallesConversacionBarbeibot
